import { SanityImage } from '#app/components/ui/SanityImage.tsx'
import {
	type SanityImageCrop,
	type SanityImageHotspot,
} from '#app/types/sanity.types.ts'

export type PersonCardImage = {
	asset: {
		_id: string
		metadata?: {
			dimensions: { width: number; height: number; aspectRatio: number }
		}
	}
	hotspot?: SanityImageHotspot
	crop?: SanityImageCrop
	alt?: string
	_type: 'image'
}

type PersonCardProps = {
	name: string
	profilePic?: PersonCardImage
	bio?: string
}

export function PersonCard({ name, profilePic, bio }: PersonCardProps) {
	return (
		<div className="bg-muted flex h-full flex-col items-center gap-3 rounded-xl border border-slate-200 p-4 text-center dark:border-slate-700">
			{profilePic ? (
				<div className="size-36 overflow-hidden rounded-full">
					<SanityImage
						source={profilePic}
						alt={name}
						className="h-full w-full object-cover"
					/>
				</div>
			) : (
				<div className="size-36 rounded-full bg-slate-200 dark:bg-slate-600" />
			)}
			<div className="font-semibold">{name}</div>
			{bio ? (
				<p className="text-sm text-slate-600 dark:text-slate-400">{bio}</p>
			) : null}
		</div>
	)
}
